var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagHaiti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.4307C32 25.2672 24.8365 32.4307 16 32.4307C7.1635 32.4307 0 25.2672 0 16.4307C0 7.59416 16 0.430664 16 0.430664C16 0.430664 32 7.59416 32 16.4307Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.4307C0 7.59416 7.1635 0.430664 16 0.430664C24.8365 0.430664 32 7.59416 32 16.4307",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 20.6047L16 19.909L10.4348 20.6047V12.2568H21.5652V20.6047Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 19.909C17.5372 19.909 18.783 18.6632 18.783 17.1264C18.783 15.5896 17.5372 14.3438 16.0004 14.3438C14.4636 14.3438 13.2178 15.5896 13.2178 17.1264C13.2178 18.6632 14.4636 19.909 16.0004 19.909Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 18.5175C16.7681 18.5175 17.391 17.8946 17.391 17.1262C17.391 16.3578 16.7681 15.7349 15.9997 15.7349C15.2313 15.7349 14.6084 16.3578 14.6084 17.1262C14.6084 17.8946 15.2313 18.5175 15.9997 18.5175Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9131 13.6479H18.0869L16 15.7349L13.9131 13.6479Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3047 15.0396H16.696V19.2135H15.3047V15.0396Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2261 18.7959H13.7738L10.4348 20.6046H21.5652L18.2261 18.7959Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagHaiti);
export default __webpack_public_path__ + "static/media/flag_haiti.f1f2e2a3d2164f35df7a477d945a65c8.svg";
export { ForwardRef as ReactComponent };